export const isValidEmail = (e) => /^[\w.+-]+@[\w-]+(\.[\w-]+)+$/.test((e || "").trim());

export const cleanPhone = (p) => (p || "").replace(/[\s\-()]/g, "");

export const validatePhone = (p) => {
  const s = cleanPhone(p);
  if (!s.startsWith("+")) return "Include country code, e.g. +91 98765 43210";
  if (s.startsWith("+91")) {
    if (!/^[6-9]\d{9}$/.test(s.slice(3))) return "Indian mobile numbers must be 10 digits starting with 6, 7, 8 or 9";
    return null;
  }
  const national = s.replace(/^\+\d{1,3}/, "");
  if (!/^\+[1-9]\d{6,12}$/.test(s) || national.length > 10) return "Enter a valid mobile with country code (max 10 digits)";
  return null;
};
